<template>
  <div class="card mb-4">
    <div class="card-body">
      <div
        v-if="title || eyebrow || $slots.actions"
        class="cg-card-head d-flex justify-content-between align-items-start flex-wrap gap-3"
      >
        <div>
          <p v-if="eyebrow" class="cg-micro mb-1">{{ eyebrow }}</p>
          <h2 v-if="title" class="cg-section-title">{{ title }}</h2>
          <p v-if="note" class="text-body-secondary small mb-0 mt-1">
            {{ note }}
          </p>
        </div>
        <div v-if="$slots.actions" class="d-flex gap-2 align-items-center">
          <slot name="actions" />
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ title?: string; note?: string; eyebrow?: string }>();
</script>
